// export const APIPath = 'http://localhost:3000/cytek/';
export const APIPath = 'http://3.83.146.222:8080/cytek/';
